<!--
# Module: 计划用水管理
-->
<template>
  <div class="manage-page">
    <div class="page-view">
      <div class="item-row" v-for="i in navMenu" :key="i.id" @click="opendialog(i.id)">
        <div class="name">
          <span>{{i.title}}</span>
        </div>
        <p class="tips">{{i.dec}}</p>
      </div>
    </div>
    <!-- 弹框表单 -->
    <div class="dialogform">
      <el-dialog
        v-if="dialog"
        title="选择年份"
        :visible.sync="dialog"
        top="0"
        width="400px"
        :before-close="handlecancel"
      >
        <!-- 选择用水计划年份 -->
        <el-form ref="saveYearform" :model="formTime" label-width="100px" :rules="saveYearRules">
          <el-form-item label="选择计划年份:" prop="planyearvalue">
            <el-date-picker v-model="formTime.planyearvalue" type="year" placeholder="选择年份"></el-date-picker>
          </el-form-item>
        </el-form>
        <div class="dialog-footer" slot="footer">
          <el-button type="primary" @click="handlecancel">取 消</el-button>
          <el-button type="success" @click="handlesave(dialogName)">下一步</el-button>
        </div>
      </el-dialog>

      <!-- 业务进度：用水计划申报状态流程模块 -->
      <common-dialog
        v-if="dialogVisible"
        :visible.sync="dialogVisible"
        :title="dialogOptions.title"
        :width="dialogOptions.width"
        :height="dialogOptions.height"
        append-to-body
        cover
      >
        <declareflow
          v-if="dialogName==='water_plan_add'"
          :planYear="currentYear"
          @cancle="dialogVisible = false"
        ></declareflow>
        <!-- 用水计划调整列表 -->
        <plan-adjust-list
          v-else-if="dialogName==='water_plan_adjust'"
          type="operation"
          :planYear="currentYear"
          @cancel="dialogVisible=false"
        ></plan-adjust-list>
      </common-dialog>
    </div>
  </div>
</template>

<script>
import declareflow from "@/components/declareflowchart/index.vue" // 申报流程图
import Adjustflow from "@/components/adjustFlowChart/index" // 调整流程图
import planAdjustList from '@/components/recordListTable/planAdjustList.vue'
export default {
  name: "waterPlanManage",
  components: {
    declareflow,
    Adjustflow,
    planAdjustList
  },
  data () {
    return {
      dialog: false, // 是否显示弹框
      dialogVisible: false, // 申报弹框
      dialogOptions: {
        title: '',
        width: '600px',
        height: ''
      },
      adjustdialog: false, // 调整弹框
      dialogName: '',
      currentYear: "",
      formTime: { planyearvalue: "" }, // 计划年份表单数据(申报用水)
      saveYearRules: { planyearvalue: [{ type: "date", required: true, message: "请选择年份", trigger: "change" }] }, // 计划年份表单验证(申报用水)
      userInfo: null // 用户信息
    }
  },
  computed: {
    // 用户信息
    basicsUser () {
      return this.$store.state.userInfo
    },
    // 选项卡：菜单导航
    navMenu () {
      return [
        { id: 'water_plan_add', title: '用水计划申报', dec: '处理用水计划申报中相关业务，包含计划申报、水表变更、水量复核、文件上传、文件下载等' },
        { id: 'water_plan_adjust', title: '计划调整申请', dec: '发起用水计划调整申请' }
      ]
    }
  },
  watch: {
    // 监听用户信息
    basicsUser (v) {
      this.userInfo = this.$initUserInfo()
    }
  },
  mounted () {
    this.$initReload()
  },
  methods: {
    // 传值：是否关闭弹框
    updateAdjust (t) {
      this.adjustdialog = t
      this.formTime.planyearvalue = new Date(this.$store.state.yearvalue)
      this.currentYear = this.$store.state.yearvalue
    },
    // 初始化：页面加载
    $initReload () {
      if (this.$store.state.ifrefresh) {
        this.userInfo = this.$store.state.userInfo
      }
    },
    // 初始化：获取基本信息(页面刷新加载)
    $initUserInfo () {
      if (this.$store.state.userInfo) {
        return this.$store.state.userInfo
      }
    },
    // 封装：格式化时间
    $filterTime (val, type) {
      let time = "--"
      if (val) {
        const timestamp = new Date(val)
        const year = timestamp.getFullYear()
        let month = timestamp.getMonth() + 1
        month = month < 10 ? "0" + month : month
        let day = timestamp.getDate()
        day = day < 10 ? "0" + day : day
        let hour = timestamp.getHours()
        hour = hour < 10 ? "0" + hour : hour
        let minutes = timestamp.getMinutes()
        minutes = minutes < 10 ? "0" + minutes : minutes
        switch (type) {
          case "yyyy-MM-dd hh:mm":
            time =
              year.toString() + "-" + month.toString() + "-" + day.toString() + ' ' + hour.toString() + ":" + minutes.toString()
            break
          case "yyyy-MM":
            time =
              year.toString() + "年" + month.toString() + "月"
            break
          case "hh:mm":
            time = hour.toString() + ":" + minutes.toString()
            break
          case "yyyy":
            time = year.toString()
            break
        }
      }
      return time
    },
    // 功能: 打开弹框,赋值
    opendialog (e) {
      this.dialogName = e
      switch (e) {
        case 'water_plan_add':
          this.currentYear = ''
          this.dialog = true
          break
        case 'water_plan_adjust':
          this.dialogOptions = {
            title: '待处理用水计划列表',
            width: '80%'
          }
          this.dialogVisible = true
          break
      }
    },
    // 功能：重置
    handlecancel () {
      this.formTime.planyearvalue = ""
      if (this.$refs.saveYearform) {
        this.$refs.saveYearform.resetFields()
      }
      this.dialog = false
    },
    // 功能：按钮事件
    handlesave (t) {
      this.$refs.saveYearform.validate((valid) => {
        if (valid) {
          this.dialog = false
          this.dialogName = t
          const _year = this.$filterTime(this.formTime.planyearvalue, 'yyyy')
          this.currentYear = _year
          switch (t) {
            case 'water_plan_add':
              this.dialogOptions = {
                title: '申报状态流程',
                width: '800px'
              }
              break
            case 'water_plan_adjust':
              this.dialogOptions = {
                title: '用水计划调整列表',
                width: '80%'
              }
              break
          }
          this.formTime.planyearvalue = null
          this.dialogVisible = true
        } else {
          this.$message({
            showClose: true,
            message: '请选择年份！',
            type: 'warning'
          })
          return false
        }
      })
    }
  }
}
</script>